export default function ClientsMarquee() {
  const clients = [
    'CUSHMAN & WAKEFIELD',
    'Jio Institute',
    'Cipla',
    'MICHELIN',
    "Masters' Union",
    'AMPM',
    'SAADAA'
  ];

  return (
    <section className="py-12 bg-transparent overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-6 mb-6 relative z-10">
        <p className="text-center text-xs font-bold text-slate-400 uppercase tracking-widest">
          Trusted by Industry Leaders
        </p>
      </div>
      <div className="relative z-10">
        <div className="flex overflow-hidden">
          <div className="flex animate-scroll gap-16">
            {[...clients, ...clients].map((client, i) => (
              <div
                key={i}
                className="flex-shrink-0 text-xl font-bold text-white/40 hover:text-white/80 transition-colors whitespace-nowrap"
              >
                {client}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
